module.exports = __webpack_public_path__ + "img/estj.0b8c89a3.png";